import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
import { Table, Modal, Button, notification, Input, Switch } from "antd";
import { Link } from "react-router-dom";
import { baseApiUrl } from "../../services/api";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';


const Partenaire = () => {
  const [nom, setNom] = useState("");
  const [image, setImage] = useState("");
  const [logo, setLogo] = useState("");

  const [categories, setCategories] = useState([]);
  const [partenaires, setPartenaires] = useState([]);

  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [viewingCategory, setViewingCategory] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [deleteCategorie, setDeleteCategorie] = useState(null);
  const [deletePartenaire, setDeletePartenaire] = useState(null);
  const [data, setData] = useState([]);


  const [lien, setLien] = useState("");


  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: message,
    });
  };



  const fetchPartenaires = async () => {
    try {
      const response = await baseApiUrl.get(
        "/partenaires/liste"
      );
      console.log("Données reçues des domaine:", response.data);

      // Vérifie que les données sont bien un tableau avant de les stocker
      setPartenaires(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Erreur lors de la récupération des domaine:", error);
    }
  };
  const truncateText = (text, wordLimit) => {
    if (typeof text !== "undefined" && text !== null) {
      const words = text.split(" ");
      if (words.length > wordLimit) {
        return words.slice(0, wordLimit).join(" ") + "..."; // Tronque et ajoute "..."
      }
      return text; // Retourne le texte sans changement si le nombre de mots est inférieur à la limite
    } else {
      return ""; // Retourne une chaîne vide si text est undefined ou null
    }
  };

  const handleAddCategory = async (e) => {
    e.preventDefault();

    if (!nom) {
      openNotificationWithIcon("error", "Veuillez remplir tous les champs.");
      return;
    }

    try {
      const formData = new FormData();
      const categorieData = { nom, lien };
      console.log("Données catégorie:", categorieData);

      formData.append("partenaire", new Blob([JSON.stringify(categorieData)], { type: "application/json" }));

      if (logo) {
        console.log("Photo ajoutée:", logo);
        formData.append("logo", logo);
      }

      const response = await baseApiUrl.post("/partenaires/creer", formData);

      // Vérifier le statut de la réponse
      if (response.status !== 200) {
        const errorText = await response.text();
        console.error("Erreur API:", errorText);
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      // Notification de succès
      openNotificationWithIcon("success", "Partenaire ajoutée avec succès.");
      fetchPartenaires();
    } catch (error) {
      openNotificationWithIcon("error", "Erreur lors de l'ajout de la catégorie.");
      console.error("Erreur détectée:", error.message || error);
    }

    resetForm();
  };




  const handleEditCategory = async (e) => {
    e.preventDefault();

    if (!nom) {
      openNotificationWithIcon("error", "Veuillez remplir le nom de la catégorie.");
      return;
    }

    const formData = new FormData();
    const categorieData = { nom, lien };
    formData.append("categorie", new Blob([JSON.stringify(categorieData)], { type: "application/json" }));

    if (image) {
      formData.append("image", image);
    }

    try {
      const response = await baseApiUrl.put(`/partenaires/${editingCategory.id}`, formData);

      console.log("Response Status:", response.status);
      console.log("Response Body:", response.data);

      if (response.status !== 200) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      const updatedCategory = response.data;

      setCategories(
        categories.map((cat) => (cat.id === updatedCategory.id ? updatedCategory : cat))
      );

      openNotificationWithIcon("success", "Domaine modifiée avec succès.");
      resetForm();
    } catch (error) {
      console.error("Erreur:", error);
      openNotificationWithIcon("error", "Erreur lors de la modification de la catégorie.");
    }
  };

  const handleStatusChange = async (key, value) => {
    // Vérifiez que key (ID du projet) est bien défini
    console.log("ID du projet:", key); // Assurez-vous que key n'est pas undefined

    if (key === undefined) {
      console.error("ID du projet est manquant !");
      return;
    }

    try {
      // Appel à l'API pour activer ou désactiver le projet
      const response = await baseApiUrl.put(
        `/partenaires/activer/${key}`,
        {
          actif: value, // Passez la valeur de l'état actif
        }
      );

      // Vous pouvez afficher la réponse de l'API si nécessaire
      console.log(response.data);
      fetchProjets(); // Réponse de l'API, vous pouvez l'utiliser pour afficher un message de succès
    } catch (error) {
      console.error("Erreur lors de la mise à jour du projet:", error); // En cas d'erreur, vous pouvez choisir de rétablir l'état précédent ou afficher un message d'erreur
      // Rétablir l'état précédent en cas d'erreur
      const revertedData = data.map((item) => {
        if (item.id === key) {
          return { ...item, actif: !value };
        }
        return item;
      });
      setData(revertedData);
      // Vous pouvez afficher la réponse de l'API si nécessaire
      //   console.log(response.data); // Réponse de l'API, vous pouvez l'utiliser pour afficher un message de succès
      // } catch (error) {
      //   console.error('Erreur lors de la mise à jour du projet:', error);
      // En cas d'erreur, vous pouvez choisir de rétablir l'état précédent ou afficher un message d'erreur
    }
  };


  const handleDelete = async (id) => {
    try {
      const response = await baseApiUrl.delete(`/partenaires/${id}`);

      if (response.status !== 200) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      setPartenaires(partenaires.filter((cat) => cat.id !== id));
      setDeleteModalVisible(false);
      setDeletePartenaire(null);
      openNotificationWithIcon("success", "Partenaire supprimé avec succès.");
    } catch (error) {
      openNotificationWithIcon(
        "error",
        "Erreur lors de la suppression du partenaire."
      );
      console.error("Erreur:", error);
    }
  };


  const resetForm = () => {
    setNom("");
    setImage("");
    setLogo("");
    setLien("");
    setIsEditMode(false);
    setEditingCategory(null);
    setIsAddModalVisible(false);
    setIsEditModalVisible(false);
    setIsViewModalVisible(false);
  };

  const handleEdit = (category) => {
    setIsEditMode(true);
    setEditingCategory(category);
    setNom(category.nom);
    setImage(category.image);
    setIsEditModalVisible(true);
  };

  const handleDeleteConfirm = (categorie) => {
    setDeleteCategorie(categorie);
    setDeleteModalVisible(true);
  };

  const handleView = (category) => {
    setViewingCategory(category);
    setIsViewModalVisible(true);
  };

  const filteredCategories = partenaires.filter((category) =>
    category.nom?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    fetchPartenaires();
  }, []);

  // -------------------------------------------

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-7 col-auto">
                {/* <h3 className="page-title">Domaines</h3> */}
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admin">Accueil</Link>
                  </li>
                  <li className="breadcrumb-item active">Partenaires</li>
                </ul><br />
                <div className="top-nav-search">
                  <input
                    className="form-control"
                    placeholder="Rechercher par nom"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-sm-5 col">
                <Button
                  type="success"
                  onClick={() => setIsAddModalVisible(true)}
                  className="float-end mt-2 btn-success"
                >
                  <FontAwesomeIcon icon={faPlus} className="me-2" /> {/* Icône ajoutée ici */}
                  Ajouter
                </Button>
              </div>
            </div>
          </div>

          <Table
            rowKey="id"
            columns={[
              { title: "Nom", dataIndex: "nom", key: "nom" },
              {
                title: "Logo",
                dataIndex: "logo",
                key: "logo",
                render: (imageName) => {
                  // Définir le chemin complet de l'image
                  const imageUrl =
                    baseApiUrl.defaults.baseURL + `/image/${imageName}`;
                  return (
                    <img
                      src={imageUrl}
                      alt="project"
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                  );
                },
              },

              {
                title: "Etat",
                dataIndex: "actif",
                key: "actif",
                render: (actif, record) => (
                  <Switch
                    checked={actif}
                    onChange={(checked) =>
                      handleStatusChange(record.id, checked)
                    }
                  />
                ),
              },
              {
                title: "Lien",
                dataIndex: "lien",
                key: "lien",
                render: (text) => truncateText(text, 1),
              },

              {
                // title: "Actions",
                // key: "actions",
                dataIndex: "actions",
                render: (text, record) => (
                  <div className="text-end">
                    <Button
                      className="ms-2 btn btn-sm bg-success-light"
                      onClick={() => handleView(record)}
                    >
                      Voir
                    </Button>
                    <Button
                      className="ms-2 btn btn-sm bg-primary-light"
                      onClick={() => handleEdit(record)}
                    >
                      Modifier
                    </Button>

                    <Button
                      className="ms-2 btn btn-sm bg-danger-light"
                      onClick={() => handleDeleteConfirm(record)}
                    >
                      Supprimer
                    </Button>

                  </div>
                ),
              },
            ]}
            dataSource={filteredCategories}
          />

          {/* Modal d'ajout de catégorie */}
          <Modal
            title="Ajouter un partenaire"
            visible={isAddModalVisible}
            onCancel={() => setIsAddModalVisible(false)}
            footer={[
              <Button key="back" onClick={() => setIsAddModalVisible(false)}>
                Annuler
              </Button>,
              <Button key="submit" type="primary" onClick={handleAddCategory}>
                Ajouter
              </Button>,
            ]}
          >
            <form onSubmit={handleAddCategory}>
              <div className="form-group">
                <label>Nom</label>
                <input
                  type="text"
                  className="form-control"
                  value={nom}
                  onChange={(e) => setNom(e.target.value)}
                />

                <label>Lien</label>
                <input
                  type="text"
                  className="form-control"
                  value={lien}
                  onChange={(e) => setLien(e.target.value)}
                />


                <label>Image</label>
                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => setLogo(e.target.files[0])}
                />
              </div>
            </form>
          </Modal>

          {/* Modal de modification de catégorie */}
          <Modal
            title="Modifier le domaine"
            visible={isEditModalVisible}
            onCancel={() => setIsEditModalVisible(false)}
            footer={[
              <Button key="back" onClick={() => setIsEditModalVisible(false)}>
                Annuler
              </Button>,
              <Button key="submit" type="primary" onClick={handleEditCategory}>
                Enregistrer les modifications
              </Button>,
            ]}
          >
            <form onSubmit={handleEditCategory}>
              <div className="form-group">
                <label>Nom</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Domaine"
                  value={nom}
                  onChange={(e) => setNom(e.target.value)}
                />
                <label>Image</label>
                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => setImage(e.target.files[0])}
                />
              </div>
            </form>
          </Modal>

          {/* Modal pour afficher les détails de la catégorie */}
          <Modal
            title="Détails du domaine"
            visible={isViewModalVisible}
            onCancel={() => setIsViewModalVisible(false)}
            footer={[
              <Button key="close" onClick={() => setIsViewModalVisible(false)}>
                Fermer
              </Button>,
            ]}
          >
            {viewingCategory && (
              <div>
                <p>
                  <strong>Nom :</strong> {viewingCategory.nom}
                </p>
                {/* Ajoutez d'autres champs ici si nécessaire */}
              </div>
            )}
          </Modal>

          <Modal
            title="Confirmer la suppression"
            visible={deleteModalVisible}
            onCancel={() => setDeleteModalVisible(false)}
            footer={[
              <Button key="back" onClick={() => setDeleteModalVisible(false)}>
                Annuler
              </Button>,
              <Button
                key="submit"
                type="primary"
                onClick={() => handleDelete(deleteCategorie.id)}
              >
                Supprimer
              </Button>,
            ]}
          >
            <p>Êtes-vous sûr de vouloir supprimer cet Domaine ?</p>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default Partenaire;
